import errorImage from '@/assets/images/error.png'
import quoteNotFoundImage from '@/assets/images/quote_not_found.png'
import { isQuotesPortalOrGuest } from '@/helpers'
import { StorefrontError } from '@/modules/error/types'
import useError from '@/modules/error/useError'
import { t } from '@/plugins/i18n'
import { Ref, computed, getCurrentInstance } from 'vue'

function customErrorHandling(): {
  error: Ref<StorefrontError>
  mustHandleError: Ref<boolean>
} {
  const componentInstance = getCurrentInstance()
  const componentName = componentInstance?.type?.name as string
  const error = computed(() => useError().getError())
  const mustHandleError = computed(() =>
    Boolean(error.value.customHandler && error.value.customHandler === componentName)
  )
  return { error, mustHandleError }
}

const getErrorImageSource = (code: number): string => {
  return isQuotesPortalOrGuest.value && (code === 404 || code === 403)
    ? quoteNotFoundImage
    : errorImage
}

const getErrorHeadline = (code: number): string => {
  return code === 404 || code === 403 ? t('errorPageOops') : t('errorPageHeadline')
}

const getErrorMessage = (code: number, message: string): string => {
  return `${code && code !== 403 ? code + ' - ' : ''}${message}`
}

export { customErrorHandling, getErrorHeadline, getErrorImageSource, getErrorMessage }
